import { writable } from 'svelte/store';

export function createMarquee() {
  let timer: ReturnType<typeof setTimeout> | null = null;
  const metadataText = writable('');
  const scrolling = writable(false);

  function clear() {
    metadataText.set('');
    scrolling.set(false);
    if (timer) { clearTimeout(timer); timer = null; }
  }

  function set(text: string | null | undefined) {
    if (timer) { clearTimeout(timer); timer = null; }
    if (text == null || text === '') {
      metadataText.set('');
      scrolling.set(false);
      return;
    }
    metadataText.set(text);
    scrolling.set(true);
  }

  function cleanup() {
    if (timer) { clearTimeout(timer); timer = null; }
  }

  return { metadataText, scrolling, clear, set, cleanup };
}
